import { defineStore } from "pinia";

export const useEventStore = defineStore("events", () => {
  const listeners = new Map<string, ((...args: any[]) => void)[]>();

  function on(event: string, callback: (...args: any[]) => void) {
    if (!listeners.has(event)) {
      listeners.set(event, []);
    }
    listeners.get(event)?.push(callback);
  }

  function off(event: string, callback?: (...args: any[]) => void) {
    if (!callback) {
      listeners.delete(event);
    } else {
      const callbacks = listeners.get(event)?.filter(cb => cb !== callback);
      if (callbacks) {
        listeners.set(event, callbacks);
      }
    }
  }

  function emit(event: string, ...args: any[]) {
    listeners.get(event)?.forEach(callback => {
      callback(...args);
    });
  }

  return { on, off, emit };
})